import _ from 'underscore';

app.LoyaltySignupCustomFieldsView = app.AccordionFieldView.extend({
  className() {
    return `${app.AccordionFieldView.prototype.className.apply(this)} loyalty-signup-custom-fields-panel`;
  },

  initialize(options) {
    _.extend(options || {}, {
      newValue() {
        return {};
      },
      // Provide the method for determining the title of the cell.
      getTitle(fieldGroupView) {
        const fields = fieldGroupView.getValue();

        return fields.key || '';
      },
      templateData: {
        title: options.schema.displayName,
        buttonText: 'new custom field',
        emptyText: 'No custom fields yet.',
      },
    });

    app.AccordionFieldView.prototype.initialize.apply(this, arguments);
  },
});
